<template>
  <MultibarChart
    :request-status="requestStatus"
    :series="rawSeries"
    :title="title"
    :item-id="itemId"
    :is-expanded-card="isExpandedCard"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import MultibarChart from '@/components/cards/models/MultibarChart';
import { mapActions } from 'vuex';
import { DATA_TYPE } from '@/store/modules/cards/constants';
import EventBus from '@/utils/event-bus';
import sacListeningModel from '@/mixins/sac-listening-model';

export default {
  name: 'SentimentByTerms',
  components: {
    MultibarChart,
  },
  mixins: [
    sacListeningModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    isExpandedCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
      classifiedPercentage: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getSacListeningWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      const promisses = [
        this.createRequisitions(DATA_TYPE.LISTENING),
        this.createRequisitions(DATA_TYPE.SAC),
      ];
      Promise.all(
        promisses
      ).then(([responseListening, responseSac]) => {
        this.rawSeries = this.aggregateResponses(responseListening.data, responseSac.data);
        this.requestStatus = 'success';

        if (options?.silentRefresh) {
          EventBus.$emit('updated', { itemId: this.itemId });
        }
      }).catch(error => {
        console.error(error);
        this.requestStatus = 'error';
      });
    },
    createRequisitions(dataType) {
      return this.getSacListeningWarroomService({
        itemId: this.itemId,
        servicePath: 'monitoringMultibar',
        filterType: dataType,
        serviceParams: {
          type: 'terms',
        },
      });
    },
  },
};
</script>

<style scoped>
</style>
